import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth, useToast } from '../hooks';
import { LoginForm } from '../components';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const { showSuccess, showError } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const from = location.state?.from?.pathname || '/';

  const handleSubmit = async ({ email, password }) => {
    setError('');
    setIsLoading(true);

    try {
      await login(email, password);
      showSuccess('Welcome back!');
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
      showError(err.message || 'Login failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-branding">
          <div className="logo">
            <img src="/logo.svg" alt="Novaro" />
          </div>
          <h1>Novaro Portal</h1>
          <p>Field Service Management Platform</p>
        </div>

        <div className="login-card">
          <div className="login-header">
            <h2>Sign in to your account</h2>
            <p>Enter your credentials to access the platform</p>
          </div>

          {error && (
            <div className="login-error">
              <span>⚠</span> {error}
            </div>
          )}

          <LoginForm onSubmit={handleSubmit} isLoading={isLoading} />

          <div className="login-footer">
            <a href="/forgot-password">Forgot your password?</a>
          </div>
        </div>

        <div className="login-help">
          <p>Need help? Contact <a href="mailto:support@novaro.io">support@novaro.io</a></p>
        </div>
      </div>
    </div>
  );
};

export default Login;
